// src/components/HomeContactoCard.jsx
import React from 'react';
import { motion } from 'framer-motion';
import TagManager from 'react-gtm-module';
import styles from './HomeContactoCard.module.scss';

const MotionDiv = motion.div;

const hover = {
  scale: 1.1,
  y: -3,
  boxShadow: '0px 4px 15px rgba(127, 236, 77, 0.7)',
  color: 'var(--primary-color-hover)',
};

const transition = { type: 'tween', ease: 'easeOut', duration: 0.2 };

const HomeContactoCard = ({ selectedCountry, onCountryChange, countries }) => {
  const handleChange = e => {
    const sel = countries.find(c => c.name === e.target.value) || null;
    onCountryChange(sel);
  };

  const handleClickContacto = () => {
    if (typeof window !== 'undefined') {
      // Obtenemos la ruta actual
      const path = window.location.pathname;
      // Normalizamos: "/" => "home", y eliminamos barras en otros casos
      const routeName =
        path === '/' ? 'home' : path.replace(/^\/|\/$/g, '');
      const eventName = `${routeName}_link_contacto`;

      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: eventName,
          event_category: null,
          event_label: null,
          value: null,
          slug: null
        }
      });
    }
    // Redirigimos a la página de contacto
    window.location.href = '/contacto';
  };

  return (
    <>
      <div className={styles.header}>
        <h3 className={styles.title}>
          Creamos valor para nuestros clientes en 19 países de Latinoamérica.
        </h3>
      </div>

      <div className={styles.card}>
        <select
          className={styles.selector}
          value={selectedCountry?.name || ''}
          onChange={handleChange}
        >
          {!selectedCountry && (
            <option value="" disabled>Selecciona un país</option>
          )}
          {countries
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(c => (
              <option key={c.name} value={c.name}>
                {c.name}
              </option>
            ))}
        </select>

        {selectedCountry ? (
          <>
            <div className={styles.details}>
              <ul>
                <li>Representante: {selectedCountry.representante}</li>
                <li>Teléfono: +{selectedCountry.telefono}</li>
                <li className={styles.address}>
                  Dirección: {selectedCountry.direccion}
                </li>
                <li>Correo: {selectedCountry.email}</li>
              </ul>
            </div>

            <div className={styles.buttonContainer}>
              <MotionDiv
                className={styles.button}
                onClick={handleClickContacto}
                style={{
                  backgroundColor: 'var(--primary-color)',
                  color: 'var(--text-color)'
                }}
                whileHover={hover}
                transition={transition}
              >
                <div className={styles.buttonContent}>COTIZAR</div>
              </MotionDiv>
            </div>
          </>
        ) : (
          <div className={styles.noSelection}>
            Selecciona un país para ver los detalles.
          </div>
        )}
      </div>
    </>
  );
};

export default HomeContactoCard;
